import { Grid, Link, Row, Spacer, Text } from "@nextui-org/react";
import type { NextPage } from "next";
import Head from "next/head";

const AboutPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>⚡SVRN Energy⚡ - About</title>
      </Head>
      <h2>About</h2>
      <Spacer />
      <h3>SVRNs</h3>
      <Row>
        <Text>
          SVRN Energy wants to change the world for the better and make Bitcoin
          & Sovereignty easily accessible for everyone!
        </Text>
      </Row>
      <Spacer />
      <Text h3>Credits</Text>
      <Row>
        <Text>
          SVRN Energy is built on Open Source Software. Checkout the projects
          that inspired and power SVRN Energy.
          <br></br>- Backend built with{" "}
          <Link
            href="https://github.com/lightsats/lightsats"
            css={{ display: "inline" }}
          >
            Lightsats
          </Link>
        </Text>
      </Row>
      <Row>
        <Text>
          - 3d icons by{" "}
          <Link href="https://vijayverma.co/" css={{ display: "inline" }}>
            realvjy
          </Link>
        </Text>
      </Row>
      <Spacer />
      <h3>Links</h3>
      <Grid.Container gap={1} justify="center">
        <Grid>
          <Link href="https://github.com/lightsats/lightsats" target="_blank">
            Github
          </Link>
        </Grid>
        <Grid>
          <Link href="https://twitter.com/svrnenergy" target="_blank">
            Twitter
          </Link>
        </Grid>
      </Grid.Container>
    </>
  );
};

export default AboutPage;
